import React, { useContext, useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { AuthContext } from "../../config/AuthContext";
import { useNavigate, useParams } from "react-router-dom";
import NavBar from "../components/NavBar";
import { Button, Card, DatePicker, Descriptions, Form, Input, Checkbox, Upload } from "antd";
import Colors from "../../styles/Colors";
import toast, { Toaster } from "react-hot-toast";
import { PutUsuariIdPerfil } from "../../dao/root/PutUsuariIdPerfil";
import { GetUsuariIdPerfil } from "../../dao/root/GetUsuariIdPerfil";
import Login from "./Login";

const Perfil = () => {
    const { isLoggedIn, userId, page } = useContext(AuthContext);
    const { id_usuari } = useParams();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);
    const [creat, setCreat] = useState(false);
    const [usuari, setUsuari] = useState<any>({});
    const [editMode, setEditMode] = useState(false);

    useEffect(() => {
        if (isLoggedIn) {
            handleLoadingChange(true);
            checkDades();
        }
    }, [id_usuari]);

    async function checkDades() {
        handleLoadingChange(true);
        const dades = await GetUsuariIdPerfil(id_usuari || userId, page);
        setUsuari(dades && dades.length > 0 ? dades[0] : {});
        handleLoadingChange(false);
    }

    const handleLoadingChange = (enable: boolean) => {
        setLoading(enable);
    };

    async function handleSave(values: any) {
        handleLoadingChange(true);
        const status = await PutUsuariIdPerfil(id_usuari || userId || "0", page || window.location.href, values);
        setEditMode(false);
        if (status === 200 || status === 201) {
            toast.success("Dades guardades correctament!");
            setCreat(true);
            await checkDades();
        } else {
            toast.error("Error guardant dades!");
            handleLoadingChange(false);
        }
    }

    if (!id_usuari || isLoggedIn) {
        return (
            <div>
                <Toaster />
                {!creat ? (
                    <div className="general">
                        <Card bordered className="elemento">
                            <h4 className="titol">Dades usuari</h4>
                            <Form form={form} layout="vertical" initialValues={usuari} onFinish={handleSave}>

                                <Form.Item name="nombre" label="Nom"
                                           rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Input/>
                                </Form.Item>
                                <Form.Item name="cognoms" label="Cognoms"
                                           rules={[{required: true, message: 'Aquest camp es obligatori'}]}>
                                    <Input/>
                                </Form.Item>
                                <Form.Item name="dni" label="DNI" rules={[{ required: true }]}>
                                    <Input />
                                </Form.Item>
                                <Form.Item name="correu" label="Correu Electrònic" rules={[{ required: true }]}>
                                    <Input />
                                </Form.Item>
                                <Button type="primary" htmlType="submit" loading={loading} style={{ backgroundColor: Colors.colors.color4 }}>Registrar</Button>
                            </Form>
                        </Card>
                    </div>
                ) : (
                    <Card bordered className="elemento">
                        <h4 className="titol">Usuari creat correctament! Rebrás un correu amb les teves credencials en breus</h4>
                    </Card>
                )}
            </div>
        );
    } else {
        return <Login />;
    }
};
export default Perfil;
